import { Button, FormHelperText, Grid } from '@mui/material';
import { CustomProductFields } from 'new/custom-product-fields';
import { useCallback, useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { defaultCustomProduct } from 'shared/constants';
import { Product } from 'shared/types';

export function CustomProductInfo() {
  const {
    watch,
    setError,
    clearErrors,
    formState: { errors, isSubmitting },
  } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    name: 'customProducts',
  });
  const watchCustomProducts = watch('customProducts');
  const watchProducts = watch('products') as Product[];

  const controlledFields = fields.map((field, index) => ({
    ...field,
    ...watchCustomProducts[index],
  }));

  useEffect(() => {
    if (isSubmitting && !fields.length && !watchProducts?.length) {
      setError('customProducts', {
        message: 'At least one product is required',
        type: 'custom',
      });
    }
  }, [fields, watchProducts, isSubmitting, setError]);

  const addCustomProduct = useCallback(() => {
    clearErrors('customProducts');
    clearErrors('products');
    append(defaultCustomProduct);
  }, [clearErrors, append]);

  const removeCustomProduct = (index: number) => () => {
    remove(index);
  };

  return (
    <Grid container spacing={2} direction='column'>
      <Grid item>
        <Button onClick={addCustomProduct} variant='contained'>
          Add Custom Product
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          {controlledFields.map((field, index) => (
            <CustomProductFields
              key={field.id}
              index={index}
              removeCustomProduct={removeCustomProduct}
              isLastCustomProduct={index === controlledFields.length - 1}
              addCustomProduct={addCustomProduct}
            />
          ))}
        </Grid>
        <Grid xs={12} item>
          <FormHelperText error>{errors?.customProducts?.message}</FormHelperText>
        </Grid>
      </Grid>
    </Grid>
  );
}
